import { initializeBookmarks } from './elements/bookmark.js';
import './blocks/core_events_list.js';

document.addEventListener('DOMContentLoaded', () => {
  initializeBookmarks();
});
